import { getPlayerKDValue, PlayerKDSortKey, PlayerKDStats } from '@shared/playerKD';

export const playerKDColumns: { key: PlayerKDSortKey; label: string }[] = [
    { key: 'kills', label: 'Kills' },
    { key: 'deaths', label: 'Mortes' },
    { key: 'kd', label: 'KD' },
    { key: 'hs', label: 'HS%' },
];

export function formatPlayerKD(stats: PlayerKDStats | null, key: PlayerKDSortKey) {
    if (!stats) return '--';
    const value = getPlayerKDValue(stats, key);
    if (value < 0) return '--';
    if (key === 'hs') {
        if (value === 0) return '--';
        const percentage = Math.round(value);
        return percentage > 0 ? `${percentage}%` : '<1%';
    }
    return key === 'kd' ? value.toFixed(2) : value.toLocaleString();
}
